import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const SharpHalfStar: FunctionalComponent<IIconProps> = ({
  width = '16',
  height = '16',
  fill = '#FAC627',
  stroke = '#8D6708',
}) => {
  return (
    /*@ts-ignore*/
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 1.02612V19.0088L4.95911 22.7107L6.30619 14.856L0.599854 9.29321L8.48582 8.14722L12 1.02612Z"
        fill={fill}
      />
      <path
        d="M12.2328 18.5574L12.0001 18.4351L11.7674 18.5574L5.61072 21.7942L6.78655 14.9386L6.83098 14.6795L6.64275 14.4961L1.66188 9.64092L8.54527 8.6407L8.8054 8.6029L8.92174 8.36718L12.0001 2.12978L15.0784 8.36718L15.1948 8.6029L15.4549 8.6407L22.3383 9.64092L17.3574 14.4961L17.1692 14.6795L17.2136 14.9386L18.3894 21.7942L12.2328 18.5574Z"
        stroke={stroke}
      />
    </svg>
  );
};

export default SharpHalfStar;
